import defaultTheme from '../../styles/themes/default';

export const selectStyle = {
  control: (styles: any) => ({
    ...styles,
    backgroundColor: defaultTheme.colors.white,
    width: '100%',
    height: '48px',
    boxShadow: 'none',
    outline: 'none',
    border: '1px solid',
    borderRadius: '8px',
    color: defaultTheme.colors.gray[400],
    padding: '0',
    maxHeight: '48px',
    cursor: 'pointer',
    overflowX: 'scroll',
    '&:hover': {
      borderColor: defaultTheme.colors.orange.primary,
    },
  }),
  indicatorsContainer: (styles: any) => ({
    ...styles,
    maxHeight: '48px',
  }),
  multiValueContainer: (styles: any) => ({
    ...styles,
    border: '4px solid !important',
    flexWrap: 'nowrap',
  }),
  multiValue: (styles: any) => ({
    ...styles,
    backgroundColor: defaultTheme.colors.gray[200],
    borderRadius: '14px',
    whiteSpace: 'nowrap',
  }),
  multiValueLabel: (styles: any) => ({
    ...styles,
    color: defaultTheme.colors.gray[600],
  }),
  multiValueRemove: (styles: any) => ({
    ...styles,
    color: defaultTheme.colors.gray[600],
    '&:hover': {
      color: defaultTheme.colors.gray[600],
    },
  }),
  container: (styles: any) => ({
    ...styles,
    width: '100%',
    outline: 'none',
    border: 'none',
    padding: '0',
    cursor: 'pointer',
  }),
  indicatorSeparator: (styles: any) => ({
    ...styles,
    display: 'none',
    border: 'none',
  }),
  option: (styles: any, { isSelected }: any) => ({
    ...styles,
    borderRadius: '8px',
    fontSize: 'clamp(12px, 2vw, 14px)',
    fontWeight: 400,
    gap: '8px',
    color: isSelected ? '#fff' : '#807E80',
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: '#C1C1C1',
      color: '#fff',
      cursor: 'pointer',
    },
    '&:focus': {
      backgroundColor: '#C1C1C1',
      color: '#fff',
      cursor: 'pointer',
    },
    '&:checked': {
      backgroundColor: defaultTheme.colors.orange.primary,
      color: '#fff',
      cursor: 'pointer',
    },

    backgroundColor: isSelected ? defaultTheme.colors.orange.primary : '#fff',
  }),
  singleValue: (styles: any) => ({
    ...styles,
    color: '#807E80',
    fontSize: '14px',
  }),
  placeholder: (styles: any) => ({
    ...styles,
    fontSize: '14px',
    fontWeight: 700,
    color: defaultTheme.colors.gray[500],
    whiteSpace: 'nowrap',
  }),
};
